"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/operator/takeUntil");
var party_defenitions_1 = require("../../../../shared/model/party-defenitions");
var SearchFiltersComponent = /** @class */ (function () {
    function SearchFiltersComponent() {
        this.partyPropertiesChange = new core_1.EventEmitter();
    }
    SearchFiltersComponent.prototype.onEnabledCheckBoxAction = function (enabledCheckbox, filterSettings) {
        filterSettings.enabled = enabledCheckbox.checked;
        this.partyPropertiesChange.emit(true);
    };
    SearchFiltersComponent.prototype.onPartyPropertySelect = function (selectedIds, filterConfig, key) {
        switch (key) {
            case 'partyRole':
                filterConfig.partyRoleIds = selectedIds;
                break;
            case 'partyType':
                filterConfig.partyTypeIds = selectedIds;
                break;
            case 'partyState':
                filterConfig.partyStateIds = selectedIds;
                break;
        }
        this.partyPropertiesChange.emit(true);
    };
    SearchFiltersComponent.prototype.onIncludeInactiveCheckboxChange = function (includeInactivePartiesCheckbox, filterConfig) {
        filterConfig.includeInactiveParties = includeInactivePartiesCheckbox.checked;
        this.partyPropertiesChange.emit(true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SearchFiltersComponent.prototype, "partyFilters", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", party_defenitions_1.PartyDefinitions)
    ], SearchFiltersComponent.prototype, "partyDefinitions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SearchFiltersComponent.prototype, "partyRoles", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SearchFiltersComponent.prototype, "partyTypes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SearchFiltersComponent.prototype, "partyStates", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SearchFiltersComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SearchFiltersComponent.prototype, "partyPropertiesChange", void 0);
    SearchFiltersComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-party-picker-search-filters',
            styles: [require('./search-filters.component.css')],
            template: require('./search-filters.component.html')
        })
    ], SearchFiltersComponent);
    return SearchFiltersComponent;
}());
exports.SearchFiltersComponent = SearchFiltersComponent;
//# sourceMappingURL=search-filters.component.js.map